import { cx } from "../utils/cx";

const toneByStatus = {
  delivered: "success",
  paid: "success",
  active: "success",
  vip: "accent",
  pending: "warning",
  packed: "info",
  "out for delivery": "accent",
  cancelled: "danger",
  refunded: "muted",
  watch: "warning",
  "out of stock": "danger",
  "in stock": "success",
  "local draft workspace": "accent",
};

function getTone(status) {
  const key = String(status || "").trim().toLowerCase();
  return toneByStatus[key] || "neutral";
}

function StatusBadge({ status, tone, compact = false }) {
  return (
    <span
      className={cx(
        "status-badge",
        `tone-${tone || getTone(status)}`,
        compact && "is-compact"
      )}
    >
      <span className="status-badge-dot" />
      {status || "Unknown"}
    </span>
  );
}

export default StatusBadge;
